<template>
  <v-container>


    <stock-result
        v-if="done"
        :remove-transaction="moveTransaction"
    />


    <v-row v-else>
      <v-col cols="12" class="text-right">
        <stock-combobox
            v-model="stockDest"
            :filtered-stock="stock"
            label="delivery.stockOperation.destinationBranch">

        </stock-combobox>
      </v-col>
      <v-col v-for="(item,index) in getItems" :key="index" cols="12" md="4">
        <product-stock
            :product="item.product"
            v-model="item.move"
            :in-stock="item.quantity"
            :minimum="item.minimum"
            validate-stock
        >
        </product-stock>
      </v-col>
      <v-col cols="12" class="text-right">
        <submit-button :disabled="!isReady" @click="moveStock"></submit-button>

      </v-col>
    </v-row>

  </v-container>

</template>

<script>
import ProductStock from "@/modules/delivery/components/ProductStock/ProductStock";
import {SubmitButton} from '@dracul/common-frontend'
import StockOperationProvider from "@/modules/delivery/providers/StockOperationProvider";
import StockCombobox from "@/modules/delivery/combobox/StockCombobox/StockCombobox";
import StockResult from "@/modules/delivery/pages/stock/StockOperationPage/StockResult/StockResult";

export default {
  name: "StockMove",
  components: {StockResult, StockCombobox, ProductStock, SubmitButton},
  props: {
    stock: Object,
  },
  data() {
    return {
      done: false,
      moveTransaction: null,
      stockDest: null,
      items: []
    }
  },

  computed: {
    getItems(){
      return this.stock.items.filter(i => i.hide === false)
    },
    getMoveItems() {
      return this.stock.items.filter(i => i.move > 0).map(i => ({product: i.product.id, quantity: i.move}))
    },
    isReady() {
      return this.stockDest && (this.itemsToMove > 0)
    },
    itemsToMove() {
      return this.stock.items.reduce((a, i) => (a + i.quantity), 0)
    }
  },
  methods: {

    moveStock() {

      if (this.itemsToMove === 0) {
        return
      }

      StockOperationProvider.moveStockOperation(this.stock.id, this.stockDest, this.getMoveItems)
          .then(r => {
            console.log(r.data.moveStockOperation)
            this.moveTransaction = r.data.moveStockOperation
            this.done = true
            this.$emit('stockMoved')
          })


    }
  }
}
</script>

<style scoped>

</style>
